// extracted by mini-css-extract-plugin
export default {"heading2":"heading2-module--heading2--DhlEW","primary":"heading2-module--primary--xayn0","secondary":"heading2-module--secondary--e9j4S","bold":"heading2-module--bold--GFEyE"};